// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"204":"262a2f2e","771":"9882a377"}[chunkId] + ".bundle.js";
};